import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import { Link, useLocation ,useParams  } from "react-router-dom";
import Product1 from "../components/Product1";
import Product2 from "../components/Product2";

import Sheet from 'react-modal-sheet';
import { BsSliders, BsCaretDownFill, BsArrowClockwise, BsListUl, BsGridFill, BsBoxSeam } from "react-icons/bs";

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import { useAxios } from "../services/useAxios";
import { useTranslation } from 'react-i18next';


export default function Categories() {
    const { t } = useTranslation();

    const [isOpen, setOpen] = useState(false);
    const [isCateOpen, setCateOpen] = useState(false);

    const location = useLocation();   
    const [cate, setCate] = useState({});
   
    let {id} = useParams();
    const [listMode, setListMode] = useState("grid");
    const [selectCate, setSelectCate] = useState(id);
    const [goodsHashtagListStr, setGoodsHashtagListStr] = useState(null);
    
    const [data, setData] = useState({});
    const [dataList, setDataList] = useState([]);
    const [tagCheckList, setTagCheckList] = useState([]);

    const [cateCheckList, setCateCheckList] = useState([]);

    const [cateFilterList, setCateFilterList] = useState([]);
    const [selectOrder, setSelectOrder] = useState('');
    const [selectDlvyFree, setDlvyFreeAt] = useState(false);
    const [selectDlvyToday, setDlvyTodayAt] = useState(false);
    const lang = localStorage.getItem("language") || "ko";
    const [request] = useAxios();

    const handleSingleCheck = (checked, id, type) => {
        if(type === 'hash'){
            if (checked) {
                // 단일 선택 시 체크된 아이템을 배열에 추가
                setTagCheckList(prev => [...prev, id]);
            } else {
                // 단일 선택 해제 시 체크된 아이템을 제외한 배열 (필터)
                setTagCheckList(tagCheckList.filter((el) => el !== id));
            }
        }else{
            if (checked) {
                // 단일 선택 시 체크된 아이템을 배열에 추가
                setCateCheckList(prev => [...prev, id]);
            } else {
                // 단일 선택 해제 시 체크된 아이템을 제외한 배열 (필터)
                setCateCheckList(cateCheckList.filter((el) => el !== id));
            }
        }
      };

    const [page, setPage] = useState(0);
    
    const fn_clTab = (obj) => {
    
        if(obj!==null){
            setSelectCate(obj.goodsClSn);
        }else{
            setSelectCate(id);
        }
        
    } 
    
    const handleSelect = (e) => {
        setSelectOrder(e.target.value);
    };
    const fetchData2 = async () => {
        const response = await request.post("/app/goods/getGoodsClListAPI", {
            nationSeCode : lang,
            goodsClSn : id,
        });

        if(response.data.resultCode === 200){                 
            setCate(response.data.result);
        }
        
        if(id === "70" || id === "71"){
            const response = await request.post("/app/goods/getGoodsInfoCtgryListAPI", {
                nationSeCode : lang,
                goodsClSn : id,
            });

            if(response.data.resultCode === 200){                               
                setCateFilterList(response.data.result.goodsInfoCtgryList)
            }
    
    
        }
    };

    const fetchData = async (pageIndex) => {
        console.log(pageIndex,cateCheckList)
        const response = await request.post("/app/goods/getGoodsListAPI", {
            nationSeCode : lang,
            goodsClSn : selectCate,
            dlvyFreeAt :selectDlvyFree===true? 'Y':'N',
            dlvyTodayAt : selectDlvyToday===true? 'Y':'N',
            orderBy : selectOrder,
            goodsClSnList : cateCheckList,
            goodsHashtagListStr: goodsHashtagListStr,
            pageIndex : pageIndex

        });
        if(response.data.resultCode === 200){           
            setData(response.data.result);
            if(pageIndex ===1){
                setDataList(response.data.result.resultList);
            }else{
                setDataList((prevData) => [...prevData, ...response.data.result.resultList]);
            }          
            
        }            
    };


    useEffect(() => {
        fetchData2();
     
      }, []);

    useEffect(() => {       
        if(page > 0){                               
           fetchData(1)                               
        }
      }, [selectCate, selectOrder, goodsHashtagListStr, cateCheckList]);


   
  useEffect(() => {    
    if(page > 0){
        fetchData(page);    
    }
  }, [page]);

  const fn_search = () => {
    setOpen(false)
    let listStr ='';
    let i = 0;
    tagCheckList.forEach((item) =>{
		if(i > 0){
			listStr += '|';
		}
		listStr += ',' + item + ',';
		i++;
	});	
    setGoodsHashtagListStr(listStr)
  }

  const handleObserver = (entries) => {
    const target = entries[0];
    if (target.isIntersecting ) {
        setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, {
      threshold: 0, //  Intersection Observer의 옵션, 0일 때는 교차점이 한 번만 발생해도 실행, 1은 모든 영역이 교차해야 콜백 함수가 실행.
    });
    // 최하단 요소를 관찰 대상으로 지정함
    const observerTarget = document.getElementById("observer");
    // 관찰 시작
    if (observerTarget) {
      observer.observe(observerTarget);
    }
  }, []);

    return(
        <div>
            <div className="backGround bgBlue"></div>
            <div className="headFixed backGround bgBlue">
                <Header type="cart" pageTitle={cate?.goodsClVO?.goodsClNm}/>
                <div className="tabArea">
                    <div className={selectCate===id ?'tabBtn active':'tabBtn'} onClick ={() => fn_clTab(null)}>{t(`Message.common_all`)}</div>
                    {cate.goodsClList && cate.goodsClList.map((obj, index) => (
                    <div className={selectCate===obj.goodsClSn ?'tabBtn active':'tabBtn'} key={index} onClick ={() => fn_clTab(obj)}>{obj.goodsClNm}</div>
                     ))}                       
                </div>
            </div>

            <div className="categoriesWr">
                <div className="fliterWr">
                    <div className="dfcsG6">
                        <button 
                            type="button" 
                            className={"filterBtn "+ (cateCheckList.length!==0?' active':null)}
                            onClick={(e) => {
                                e.preventDefault(); 
                                e.stopPropagation(); 
                                setCateOpen(true);
                            }}
                        >
                            <BsBoxSeam />
                            <span>Category</span>
                        </button>

                        <button 
                            type="button" 
                            className={"filterBtn "+ (tagCheckList.length!==0?' active':null)}
                            onClick={(e) => {
                                e.preventDefault(); 
                                e.stopPropagation(); 
                                setOpen(true);
                            }}
                        >
                            <BsSliders />
                            <span>HASHTAG</span>
                        </button>
                    </div>
                    {/* <select onChange={handleSelect} className="sort">
                        <option value="popular">{t(`Message.goods_list_screen_ordr_popular`)}</option>
                        <option value="recent">{t(`Message.goods_list_screen_ordr_recent`)}</option>
                        <option value="lowPrice">{t(`Message.goods_list_screen_ordr_lowPrice`)}</option>
                        <option value="highPrice">{t(`Message.goods_list_screen_ordr_highPrice`)}</option>
                        <option value="order">{t(`Message.goods_list_screen_ordr_order`)}</option>
                        <option value="review">{t(`Message.goods_list_screen_ordr_review`)}</option>
                    </select> */}
                    <div className="dfceG6">
                        <button type="button" className={listMode === 'grid'?"swapBtn active":"swapBtn"} onClick={(e)=>setListMode("grid")}><BsGridFill /></button>
                        <button type="button" className={listMode === 'list'?"swapBtn active":"swapBtn"} onClick={(e)=>setListMode("list")}><BsListUl /></button>
                    </div>
                </div>

                {listMode === 'grid'?(
                    <div className="ct2">
                    {dataList && dataList.map((obj, index) => (
                        
                    <Product1 key={index}
                        img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                        type="type2"
                        prodName={obj.goodsNm}
                        disprice={"￦"+(!obj.sleAmount?0:obj.sleAmount).toLocaleString('ko-KR')}
                        percent={Math.round(!obj.dscntRate?0:obj.dscntRate * 100)}
                        cost={"￦"+(!obj.nrmltAmount?0:obj.nrmltAmount).toLocaleString('ko-KR')}
                        heart={true}
                        cart={true}
                        obj = {obj}
                    />
                    ))}     
                    </div>    
                ):(
                    <>
                     {dataList && dataList.map((obj, index) => (
                    
                        <Product2 key={index}
                            img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                            type="type5"
                            prodName={obj.goodsNm}
                            disprice={"￦"+(!obj.sleAmount?0:obj.sleAmount).toLocaleString('ko-KR')}
                            percent={Math.round(!obj.dscntRate?0:obj.dscntRate * 100)}
                            cost={"￦"+(!obj.nrmltAmount?0:obj.nrmltAmount).toLocaleString('ko-KR')}
                            heart={true}
                            cart={true}
                            obj = {obj}
                        />
                        ))}    
                    </> 
                )}

                <div id="observer" style={{ height: "10px" }}></div>

               
            </div>





            <Sheet isOpen={isOpen} onClose={() => setOpen(false)} className="bottomModal">
                <Sheet.Container>
                <Sheet.Header />
                <Sheet.Content>
                    <div className="dfColG16 btModalArea">
                        <div className="dfsb">
                            <h3 className="btModalTit">{t(`Message.goods_list_screen_filter_btn`)}</h3>
                            <button type="button" className="btn24 cFFF greenB dfcsG4 fs13" onClick={(e) => setTagCheckList([])} ><BsArrowClockwise /> {t(`Message.goods_list_screen_init_btn`)}</button>
                        </div>
                        <div className="modalTabWr">
                            <ul className="chkWr dfColG12">
                                {data.goodsInfoHashtagList && data.goodsInfoHashtagList.map((obj, index) => (
                                <li key={index}>
                                    <input type="checkbox"  id={"id_hashtag"+index}  
                                    checked={tagCheckList.includes(obj.hashtag) ? true : false} onChange={(e) => handleSingleCheck(e.target.checked, obj.hashtag, 'hash')} />
                                    <label htmlFor={"id_hashtag"+index}>{obj.hashtag}</label>
                                </li>
                                ))}                                                                 
                            </ul>
                        </div>                        
                    </div>
                    <div className="btnWr">
                        <button type="button" className="btn40 wgB cDisa" onClick={() => setOpen(false)}>{t(`Message.common_cancel`)}</button>
                        <button type="button" className="btn40 orgB cFFF" onClick={() => fn_search()}>{t(`Message.goods_list_screen_filter_search_btn`)}</button>
                    </div>
                </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop onClick={() => setOpen(false)}/>
            </Sheet>


            <Sheet isOpen={isCateOpen} onClose={() => setCateOpen(false)} className="bottomModal">
                <Sheet.Container>
                <Sheet.Header />
                <Sheet.Content>
                    <div className="dfColG16 btModalArea">
                        <div className="dfsb">
                            <h3 className="btModalTit">{t(`Message.goods_list_screen_filter_btn`)}</h3>
                            <button type="button" className="btn24 cFFF greenB dfcsG4 fs13" onClick={(e) => setCateCheckList([])} ><BsArrowClockwise /> {t(`Message.goods_list_screen_init_btn`)}</button>
                        </div>
                        <div className="modalTabWr">
                            <ul className="chkWr dfColG12">
                                {cateFilterList  && cateFilterList.length !==0 && cateFilterList.map((obj, index) => (
                                <li key={index}>
                                    <input type="checkbox"  id={"id_cate"+index}  
                                    checked={cateCheckList.includes(obj.goodsClSn) ? true : false} onChange={(e) => handleSingleCheck(e.target.checked, obj.goodsClSn, 'cate')} />
                                    <label htmlFor={"id_cate"+index}>{obj.ctgry}</label>
                                </li>
                                ))}                                                                 
                            </ul>
                        </div>                        
                    </div>
                    <div className="btnWr">
                        <button type="button" className="btn40 wgB cDisa" onClick={() => setCateOpen(false)}>{t(`Message.common_cancel`)}</button>
                        <button type="button" className="btn40 orgB cFFF" onClick={() => setCateOpen(false)}>{t(`Message.goods_list_screen_filter_search_btn`)}</button>
                    </div>
                </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop onClick={() => setCateOpen(false)}/>
            </Sheet>
        </div>
    )
}